import type { FiltersConfig } from "@dealer-center/ddc-pages-inventory-archiver-interface";

export const filters: FiltersConfig = {
  providerId: { name: "providerId", label: "Provider ID", type: "string" },
  sourceId: { name: "sourceId", label: "Source ID", type: "string" },
  dateTime: { name: "dateTime", label: "Date Time", type: "string" },
  active: { name: "active", label: "Active", type: "boolean" },
  skipVehicle: { name: "skipVehicle", label: "Skip Vehicle", type: "boolean" },
  status: { name: "status", label: "Status", type: "string" },
  type: { name: "type", label: "Type", type: "string" },
  classification: {
    name: "classification",
    label: "Classification",
    type: "string"
  },
  certified: { name: "certified", label: "Certified", type: "boolean" },
  stockNumber: { name: "stockNumber", label: "Stock Number", type: "string" },
  vin: { name: "vin", label: "VIN", type: "string" },
  modelCode: { name: "modelCode", label: "Model Code", type: "string" },
  year: { name: "year", label: "Year", type: "number" },
  make: { name: "make", label: "Make", type: "string" },
  model: { name: "model", label: "Model", type: "string" },
  trim: { name: "trim", label: "Trim", type: "string" },
  bodyStyle: { name: "bodyStyle", label: "Body Style", type: "string" },
  doors: { name: "doors", label: "Doors", type: "number" },
  driveline: { name: "driveline", label: "Driveline", type: "string" },
  transmission: { name: "transmission", label: "Transmission", type: "string" },
  engine: { name: "engine", label: "Engine", type: "string" },
  engineSize: { name: "engineSize", label: "Engine Size", type: "number" },
  wheelbase: { name: "wheelbase", label: "Wheelbase", type: "string" },
  cab: { name: "cab", label: "Cab", type: "string" },
  bed: { name: "bed", label: "Bed", type: "string" },
  fuel: { name: "fuel", label: "Fuel Type", type: "string" },
  cityMpg: { name: "cityMpg", label: "City MPG", type: "number" },
  highwayMpg: { name: "highwayMpg", label: "Highway MPG", type: "number" },
  mileage: { name: "mileage", label: "Mileage", type: "number" },
  retailValue: { name: "retailValue", label: "Retail Value", type: "number" },
  invoicePrice: {
    name: "invoicePrice",
    label: "Invoice Price",
    type: "number"
  },
  askingPrice: { name: "askingPrice", label: "Asking Price", type: "number" },
  wholesalePrice: {
    name: "wholesalePrice",
    label: "Wholesale Price",
    type: "number"
  },
  msrp: { name: "msrp", label: "MSRP", type: "number" },
  salePrice: { name: "salePrice", label: "Sale Price", type: "number" },
  eleadPrice: { name: "eleadPrice", label: "Elead Price", type: "number" },
  eleadPriceLessOemCash: {
    name: "eleadPriceLessOemCash",
    label: "Elead Price Less OEM Cash",
    type: "number"
  },
  dealerFee: { name: "dealerFee", label: "Dealer Fee", type: "number" },
  discount: { name: "discount", label: "Discount", type: "number" },
  actualCashValue: {
    name: "actualCashValue",
    label: "Actual Cash Value",
    type: "number"
  },
  salesCost: { name: "salesCost", label: "Sales Cost", type: "number" },
  kbbValue: { name: "kbbValue", label: "KBB Value", type: "number" },
  comments: { name: "comments", label: "Comments", type: "string" },
  options: { name: "options", label: "Options", type: "string" },
  optionCodes: { name: "optionCodes", label: "Option Codes", type: "string" },
  packageCodes: {
    name: "packageCodes",
    label: "Package Codes",
    type: "string"
  },
  extColor: { name: "extColor", label: "Exterior Color", type: "string" },
  extColorCode: {
    name: "extColorCode",
    label: "Exterior Color Code",
    type: "string"
  },
  intColor: { name: "intColor", label: "Interior Color", type: "string" },
  intColorCode: {
    name: "intColorCode",
    label: "Interior Color Code",
    type: "string"
  },
  image: { name: "image", label: "Image", type: "string" },
  lotDate: { name: "lotDate", label: "Lot Date", type: "string" },
  auxOptionData: {
    name: "auxOptionData",
    label: "Aux Option Data",
    type: "string"
  },
  autonationCustomerCash: {
    name: "autonationCustomerCash",
    label: "Autonation Customer Cash",
    type: "string"
  },
  autonationAccessories: {
    name: "autonationAccessories",
    label: "Autonation Accessories",
    type: "string"
  },
  autonationMsrpAdv: {
    name: "autonationMsrpAdv",
    label: "Autonation MSRP Adv",
    type: "string"
  },
  autonationMsrpBeforePkgDisc: {
    name: "autonationMsrpBeforePkgDisc",
    label: "Autonation MSRP Before Package Discount",
    type: "string"
  },
  autonationPkgDisc: {
    name: "autonationPkgDisc",
    label: "Autonation Package Discount",
    type: "string"
  },
  customPrice01: {
    name: "customPrice01",
    label: "Custom Price 01",
    type: "string"
  },
  customPrice02: {
    name: "customPrice02",
    label: "Custom Price 02",
    type: "string"
  },
  customPrice03: {
    name: "customPrice03",
    label: "Custom Price 03",
    type: "string"
  },
  customPrice04: {
    name: "customPrice04",
    label: "Custom Price 04",
    type: "string"
  }
};
